import {
  heroContent,
  featuresContent,
  howItWorksContent,
  testimonialsContent,
  pricingContent,
  ctaContent,
  privacyContent,
} from "../../data/content"

// This hook would fetch data from the API(backend stuff yikes.)
// For now, it returns mock data.
export const useContent = () => {
  return {
    hero: heroContent,
    features: featuresContent,
    howItWorks: howItWorksContent,
    testimonials: testimonialsContent,
    pricing: pricingContent,
    cta: ctaContent,
    privacy: privacyContent,
  }
}
